<script>
import apiEndpoints from "@/services/apiEndpoints";
import DatePicker from "vue2-datepicker";
import systemCode from "@/mixins/systemCode";
import reservationTime from "@/mixins/reservationTime";
import sweetAlert from "@/mixins/sweetAlert";
import required from "vuelidate/lib/validators";
import user from "@/mixins/user";

export default {
  components: {
    DatePicker
  },
  mixins: [systemCode, reservationTime, sweetAlert, user],
  data() {
    return {
      data: null,
      isLoading: false,
      status: "",
      form: {
        display_start_date: "",
        display_end_date: "",
        title: "",
        content: "",
        is_output_priority: 0,
        is_auto_creation: 0
      }
    };
  },
  created() {},
  methods: {
    async submit() {
      this.isLoading = true;
      let id =
        this.data?.hasOwnProperty("id") && this.data.id ? this.data.id : "";
      let url = apiEndpoints.update_or_create_discharger_site_notification(id);
      const sendApiProject = await this.$http.post(url, this.form);
      this.isLoading = false;
      const { status, data } = sendApiProject;
      if (status && data.result) {
        this.$emit("onUpdateData", data.result);
        if (this.status === "create") {
          this.successToast("お知らせの登録に成功しました", false, 3000);
        } else {
          this.successToast("お知らせの更新に成功しました", false, 3000);
        }
      } else {
        this.errorToast(data.message);
      }
      this.$bvModal.hide("notification-input");
    },
    async delete() {
      this.isLoading = true;
      let url = apiEndpoints.delete_discharger_site_notification(this.data.id);
      const sendApiProject = await this.$http.delete(url);
      this.isLoading = false;
      const { status, data } = sendApiProject;
      if (status) {
        this.$emit("onUpdateData");
        this.successToast("お知らせの削除に成功しました", false, 3000);
      } else {
        this.errorToast(data.message);
      }
      this.$bvModal.hide("notification-input");
    },
    closeModal() {
      this.$bvModal.hide("notification-input");
    },
    openModal(notification = null) {
      this.data = notification?.title ? notification : null;

      if (this.data == null) {
        this.status = "create";
      } else {
        this.status = "edit";
      }

      this.form = {
        display_start_date: notification?.display_start_date ?? "",
        display_end_date: notification?.display_end_date ?? "",
        title: notification?.title ?? "",
        content: notification?.content ?? "",
        is_output_priority: notification?.is_output_priority ?? 0
      };
      this.$nextTick(() => {
        this.$bvModal.show("notification-input");
      });
    },
    handleDelete() {
      if (!this.data.hasOwnProperty("id")) return;
      this.confirm(
        "",
        "",
        "お知らせを削除してもよろしいですか。",
        "warning",
        "削除",
        "キャンセル"
      ).then(async result => {
        if (!result.isConfirmed) return;

        this.delete();
      });
    },
  },
  computed: {
    checkValidate() {
      let data = this.form;
      if (
        data.display_start_date == "" ||
        data.display_end_date == "" ||
        data.title == "" ||
        data.content == "" ||
        data.is_output_priority == null ||
        new Date(data.display_start_date) > new Date(data.display_end_date)
      )
        return false;
      return true;
    },
  },
  watch: {
  },
  validations: {
    form: {
      display_start_date: { required },
      display_end_date: { required },
      title: { required },
      content: { required },
    },
  },
};
</script>

<template>
  <div class="mb-2 d-xl-flex">
    <!-- modal area -->
    <b-modal
      size="lg"
      id="notification-input"
      centered
      title-class="font-18"
      hide-footer
      title="お知らせ情報"
    >
      <b-row>
        <div class="row mt-2">
          <div class="custom-from-to-date col-4 input-with-checkbox">
            <label class="fw-bold" for="">表示日</label>
            <div>
              <date-picker
                lang="ja"
                placeholder="YYYY-MM-DD"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                position="left"
                v-model="form.display_start_date"
              ></date-picker>
            </div>
            <div class="align-self-center">～</div>
            <div>
              <date-picker
                lang="ja"
                placeholder="YYYY-MM-DD"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                position="left"
                v-model="form.display_end_date"
              ></date-picker>
            </div>
          </div>

          <div class="row mt-4">
            <b-col cols="9">
              <div class="custom-input gap-2">
                <label for="">タイトル</label>
                <b-form-input
                  name="title"
                  v-model="form.title"
                  type="text"
                ></b-form-input>
              </div>
            </b-col>
          </div>
          <div class="row mt-4">
            <b-col cols="3">
              <div class="custom-input gap-2">
                <label for="">優先表示</label>
                <b-form-checkbox
                  v-model="form.is_output_priority"
                  :value="1"
                  :uncheck="0"
                />
              </div>
            </b-col>
          </div>
          <b-row class="mt-4 mb-2">
            <b-col cols="12">
              <div class="custom-textarea gap-2">
                <label class="fw-bold" for="remarks">内容</label>
                <b-form-textarea
                  rows="4"
                  max-rows="6"
                  v-model="form.content"
                ></b-form-textarea>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="d-flex justify-content-center mt-4 gap-4 button-area">
          <button
            @click="submit"
            class="btn btn-primary waves-effect waves-light"
            v-if="this.status == 'create'"
            :disabled="!checkValidate"
          >
            <i class="fas fa-pencil-alt"></i> {{ this.$lang.button.register }}
          </button>
          <button
            @click="submit"
            class="btn btn-primary waves-effect waves-light"
            v-if="this.status == 'edit' && canUserEdit()"
            :disabled="!checkValidate"
          >
            更新
          </button>
        </div>
        <b-button
          @click="handleDelete"
          v-if="this.status == 'edit' && canUserDelete()"
          class="btn-custom-red delete-button"
        >
          <i class="fas fa-eraser"></i> 削除
        </b-button>
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
p.white-space-pre {
  margin-top: 3px;
  margin-bottom: 3px;
}
.custom-input {
  align-items: center;
}
.custom-input label {
  font-weight: 600;
  flex: 0 0 100px;
}
.col-gap-5 {
  column-gap: 3rem !important;
}
.custom-radio-group .label-group {
  flex: 1 0 100px;
  align-self: center;
}
.custom-radio-group .custom-radio input {
  margin-bottom: 0px;
}
.custom-textarea label {
  flex: 1 0 100px;
  align-self: center;
}
.mx-input:disabled {
  color: #495057 !important;
}
.button-area {
  width: 40%;
  margin-left: 30%;
}
.delete-button {
  width: 80px;
  height: 38px;
  margin-top: 24px;
  margin-left: 13%;
}
#notification-input {
  padding-bottom: 2rem;
}
</style>
